import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

export const ForwardCardField = ({
  tokenizerRef,
  onTokenizeRef,
  paymentIntentSecret,
  fwdFieldLoadingState,
}) => {
  const cardFieldRef = useRef(null);
  const unmountRef = useRef(null);

  const formMethods = useFormContext();
  const { setValue, setError } = formMethods;

  useEffect(() => {
    const resetValues = () => {
      tokenizerRef.current = null;
      onTokenizeRef.current = null;
      setValue('cardData', null);
      fwdFieldLoadingState.stop();
    };

    const initializeCardElement = async () => {
      try {
        const cardElement = await window.Forward.createCardElement({
          apiKey: FORWARD_PUBLIC_KEY,
          clientSecret: paymentIntentSecret,
        });
        unmountRef.current = cardElement.mount('#fwd-card-field', {
          style: {
            inputHeight: '40px',
            inputBackgroundColor: 'hsl(200, 20%, 100%)',
            errorColor: 'hsl(345, 100%, 45%)',
            fontSize: '0.875rem',
            fontFamily: 'Inter, sans-serif',
            textColor: 'hsl(200, 20%, 40%)',
            borderWidth: '1px',
            borderColor: 'hsl(200, 20%, 70%)',
            borderRadius: '3px',
          },
          onChange: (event) => {
            if (!event.ready) {
              resetValues();
              return;
            }
            const { card, billingDetails } = event;
            setValue('cardData', {
              type: card.brand,
              lastFour: card.lastFourDigits,
              expiry: `${card.expMonth}/20${card.expYear}`,
              zipcode: billingDetails?.address?.postalCode,
            });
          },
          onReady: (tokenize) => {
            tokenizerRef.current = tokenize;
          },
          onSuccess: async ({ token, pineappleResponse }) => {
            // Pineapple Gateway Response
            //{
            //  tokenType: string,
            //  card: { token: string, type: string, lastFour: string, expiry: string },
            //  account: string | null,
            //  blob: string | null,
            //};
            onTokenizeRef.current({
              forwardToken: token,
              pineappleToken: pineappleResponse?.card?.token || null,
            });
            resetValues();
          },
          onError: (error) => {
            resetValues();
            // eslint-disable-next-line no-console
            console.log('Error tokenizing card:', error);
            setError('cardData', {
              type: 'custom',
              message: 'Could not validate credit card data',
            });
            return;
          },
        });
      } catch (error) {
        console.error('Error initializing card element:', error);
      }
    };

    initializeCardElement();

    return () => {
      if (unmountRef.current) {
        unmountRef.current();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentIntentSecret, setError, setValue, tokenizerRef, onTokenizeRef]);

  return <div id="fwd-card-field" ref={cardFieldRef} />;
};
